import React, { useState, useEffect, useMemo } from "react";
import Scrollspy from "react-scrollspy";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

const VOLUNTEER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>`;

const DONATE_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.64-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.74-2.4 1.42 0 .73.57 1.2 2.48 1.68 2.49.62 4.38 1.51 4.38 3.63 0 1.47-.97 2.84-3.13 3.16z"/></svg>`;

const withSiteNav = (menu = []) => {
  const next = [...(menu || [])];
  const styleSource =
    next.find((item) => /about|service|contact/i.test(item.path || "")) ||
    next[1] ||
    next[0];
  const extras = [
    {
      path: "volunteer",
      label: {
        text: "Volunteer",
        color: { hex: styleSource?.label?.color?.hex || "#ffffff" },
      },
      hover: { hex: styleSource?.hover?.hex || "#f52225" },
      svg: VOLUNTEER_SVG,
    },
    {
      path: "donate",
      label: {
        text: "Donate",
        color: { hex: styleSource?.label?.color?.hex || "#ffffff" },
      },
      hover: { hex: styleSource?.hover?.hex || "#f52225" },
      svg: DONATE_SVG,
    },
  ].filter((item) => !next.some((existing) => existing.path === item.path));

  if (extras.length === 0) return next;

  const contactIndex = next.findIndex((item) =>
    /contact/i.test(item.path || item.label?.text || "")
  );
  const insertAt = contactIndex >= 0 ? contactIndex : next.length;
  next.splice(insertAt, 0, ...extras);
  return next;
};

export default function Header({ data }) {
  const [navbar, setNavbar] = useState(false);
  const [active, setActive] = useState("");
  const header = data?.header;
  const menu = useMemo(
    () => withSiteNav(header?.menu),
    [header?.menu]
  );
  const list = useMemo(() => menu.map((item) => item.path), [menu]);

  useEffect(() => {
    const changeBackground = () => {
      setNavbar(window.scrollY >= 80);
    };
    window.addEventListener("scroll", changeBackground);
    return () => window.removeEventListener("scroll", changeBackground);
  }, []);

  const mobileNav = (e) => {
    setActive(e?.id);
  };

  if (list.length === 0) return null;
  return (
    <>
      <div className={navbar ? "civsav_tm_topbar animate" : "civsav_tm_topbar"}>
        <div className="in">
          <div className="topbar_inner">
            <div className="logo">
              <Link to="/">
                <div
                  style={{
                    height: header?.logo?.height,
                    width: header?.logo?.width,
                  }}
                >
                  <GatsbyImage
                    image={header.logo?.image?.asset?.gatsbyImageData}
                    alt={data?.header?.logo?.alt}
                  />
                </div>
              </Link>
            </div>
            <div className="menu">
              <Scrollspy
                className="anchor_nav"
                items={list}
                currentClassName="current"
                offset={-88}
              >
                {menu.map((item, index) => (
                  <li className={`${index === 0 ? "current" : ""}`} key={item.path}>
                    <a href={`#${item.path}`}>
                      <span
                        className="first"
                        style={{ color: item?.label?.color?.hex }}
                      >
                        {item.label?.text}
                      </span>
                      <span
                        className="second"
                        style={{ color: item?.hover?.hex }}
                      >
                        {item.label?.text}
                      </span>
                    </a>
                  </li>
                ))}
              </Scrollspy>
            </div>
          </div>
        </div>
      </div>

      <div className="mobile-menu-wrapper">
        <Scrollspy
          className="mobile_menu-icon"
          items={list}
          currentClassName="current"
          offset={-65}
          onUpdate={mobileNav}
        >
          {menu.map((item, index) => (
            <li className={`${index === 0 ? "current" : ""}`} key={item.path}>
              <a href={`#${item.path}`}>
                <div
                  dangerouslySetInnerHTML={{ __html: item.svg }}
                  className="flex justify-center"
                  style={{
                    color:
                      item.path === active
                        ? item?.hover?.hex
                        : item?.label?.color?.hex,
                  }}
                />
                <span
                  style={{
                    color:
                      item.path === active
                        ? item?.hover?.hex
                        : item?.label?.color?.hex,
                  }}
                >
                  {item.label?.text}
                </span>
              </a>
            </li>
          ))}
        </Scrollspy>
      </div>
    </>
  );
}
